import React, { useRef, useState, useEffect } from "react";
import "./index.css";
import { MdKeyboardArrowUp } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";

const Scroller = ({ items }) => {
  const listRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(2); // Default active item index
  const isScrollingRef = useRef(false);

  useEffect(() => {
    const list = listRef.current;

    const handleWheel = (event) => {
      if (!isScrollingRef.current) {
        const direction = event.deltaY > 0 ? 1 : -1;
        const newIndex = activeIndex + direction;

        if (newIndex >= 0 && newIndex < items.length) {
          setActiveIndex(newIndex);
          isScrollingRef.current = true;

          setTimeout(() => {
            isScrollingRef.current = false;
          }, 300); // Add a small delay to prevent excessive scrolling
        }
      }
    };

    list.addEventListener("wheel", handleWheel);

    return () => {
      list.removeEventListener("wheel", handleWheel);
    };
  }, [activeIndex, items.length]);

  useEffect(() => {
    centerActiveItem();
  }, [activeIndex]);

  const centerActiveItem = () => {
    if (listRef.current) {
      const list = listRef.current;
      const activeItem = list.children[activeIndex];
      const listHeight = list.offsetHeight;
      const itemHeight = activeItem.offsetHeight;
      const scrollOffset =
        activeItem.offsetTop - listHeight / 2 + itemHeight / 2;

      list.scrollTo({
        top: scrollOffset,
        behavior: "smooth",
      });
    }
  };

  const scrollUp = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const scrollDown = () => {
    if (activeIndex < items.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  return (
    <div className="scroller-container">
      {/* Scroll Up Button */}
      <button className="scroll-button up" onClick={scrollUp}>
        <MdKeyboardArrowUp color="#FFFFFF" />
      </button>

      {/* Scrollable List */}
      <div className="scroller" ref={listRef}>
        {items.map((item, index) => (
          <div
            key={index}
            className={`scroller-item ${
              index === activeIndex ? "active" : "inactive"
            }`}
          >
            <div className="date">{item.date}</div>
            <div className="description">{item.description}</div>
          </div>
        ))}
      </div>

      {/* Scroll Down Button */}
      <button className="scroll-button down" onClick={scrollDown}>
        <MdKeyboardArrowDown color="#FFFFFF" />
      </button>
    </div>
  );
};

const CalenderData = () => {
  const items = [
    {
      date: "23 June 2024",
      description: "Physical Wellness Session by Dr XYZ",
    },
    { date: "24 June 2024", description: "Yoga and Mindfulness Workshop" },
    { date: "24 June 2024", description: "Nutrition and Health Talk" },
    { date: "25 June 2024", description: "Fitness Bootcamp with Trainer ABC" },
    { date: "26 June 2024", description: "Stress Management Session" },
    { date: "27 June 2024", description: "Advanced Yoga Techniques" },
  ];

  return (
    <div className="scroller-box">
      <Scroller items={items} />
    </div>
  );
};

export default CalenderData;
